const React = require('react');

const Container = require('../common/Container.jsx');
const _TypeConfig = require('../common/TypeConfig.jsx');
const Utilities = require('../utility/Utilities.jsx');

function Address(props) {
    const data = props.data || {};
    const config = props.config || {};
    let blockProps = {};
    let includes = {};
    if (config.Config) {
        if (config.Config.Block) {
            blockProps = config.Config.Block;
        }
        if (config.Config.Includes) {
            includes = config.Config.Includes;
        }
    }

    // Determine the visible address and contact information
    const styleAddress = Utilities.Config.getStyle(data, blockProps, 'Address');
    styleAddress.marginBottom = undefined;
    const addressLineStyle = { ...styleAddress };
    if (!Utilities.isNullOrWhitespace(blockProps.lineSpacingAddress)) {
        addressLineStyle.marginTop = blockProps.lineSpacingAddress;
    }
    let content = [];
    let hasAddress = false;
    if (blockProps.addressType == 'billing' || (blockProps.addressType == 'shipping' && data.BilledToShippingAddress && (data.BilledToShippingAddress.LineOne || data.BilledToShippingAddress.LineTwo || data.BilledToShippingAddress.LocationWithZip || data.BilledToShippingAddress.Country))) {
        hasAddress = true;
    }
    if (hasAddress) {
        if (includes.ContactName && !Utilities.isNullOrWhitespace(data.BilledToName)) {
            content.push(<div key="name">{data.BilledToName}</div>);
        }
        if (includes.SpouseName && !Utilities.isNullOrWhitespace(data.BilledToSpouseName)) {
            content.push(<div key="spouse">{data.BilledToSpouseName}</div>)
        }
        if (includes.Company && !Utilities.isNullOrWhitespace(data.BilledToCompany)) {
            content.push(<div key="company" style={content.length > 0 ? addressLineStyle : undefined}>{data.BilledToCompany}</div>);
        }
        if (blockProps.addressType == 'billing' && data.BilledToAddress) {
            if (!Utilities.isNullOrWhitespace(data.BilledToAddress.LineOne)) {
                content.push(<div key="line1" style={content.length > 0 ? addressLineStyle : undefined}>{data.BilledToAddress.LineOne}</div>);
            }
            if (!Utilities.isNullOrWhitespace(data.BilledToAddress.LineTwo)) {
                content.push(<div key="line2" style={content.length > 0 ? addressLineStyle : undefined}>{data.BilledToAddress.LineTwo}</div>);
            }
            if (!Utilities.isNullOrWhitespace(data.BilledToAddress.LocationWithZip)) {
                content.push(<div key="location" style={content.length > 0 ? addressLineStyle : undefined}>{data.BilledToAddress.LocationWithZip}</div>);
            }
            if (!Utilities.isNullOrWhitespace(data.BilledToAddress.Country)) {
                content.push(<div key="country" style={content.length > 0 ? addressLineStyle : undefined}>{data.BilledToAddress.Country}</div>);
            }
        }
        if (blockProps.addressType == 'shipping' && data.BilledToShippingAddress) {
            if (!Utilities.isNullOrWhitespace(data.BilledToShippingAddress.LineOne)) {
                content.push(<div key="line1" style={content.length > 0 ? addressLineStyle : undefined}>{data.BilledToShippingAddress.LineOne}</div>);
            }
            if (!Utilities.isNullOrWhitespace(data.BilledToShippingAddress.LineTwo)) {
                content.push(<div key="line2" style={content.length > 0 ? addressLineStyle : undefined}>{data.BilledToShippingAddress.LineTwo}</div>);
            }
            if (!Utilities.isNullOrWhitespace(data.BilledToShippingAddress.LocationWithZip)) {
                content.push(<div key="location" style={content.length > 0 ? addressLineStyle : undefined}>{data.BilledToShippingAddress.LocationWithZip}</div>);
            }
            if (!Utilities.isNullOrWhitespace(data.BilledToShippingAddress.Country)) {
                content.push(<div key="country" style={content.length > 0 ? addressLineStyle : undefined}>{data.BilledToShippingAddress.Country}</div>);
            }
        }
        if (includes.PhoneHome && !Utilities.isNullOrWhitespace(data.BilledToPhoneHome)) {
            content.push(<div key="phoneHome" style={content.length > 0 ? addressLineStyle : undefined}>Phone (Home): {data.BilledToPhoneHome}</div>);
        }
        if (includes.PhoneMobile && !Utilities.isNullOrWhitespace(data.BilledToPhoneMobile)) {
            content.push(<div key="phoneMobile" style={content.length > 0 ? addressLineStyle : undefined}>Phone (Mobile): {data.BilledToPhoneMobile}</div>);
        }
        if (includes.PhoneOther && !Utilities.isNullOrWhitespace(data.BilledToPhoneOther)) {
            content.push(<div key="phoneOther" style={content.length > 0 ? addressLineStyle : undefined}>Phone (Other): {data.BilledToPhoneOther}</div>);
        }
        if (includes.Email && !Utilities.isNullOrWhitespace(data.BilledToEmail)) {
            content.push(<div key="email" style={content.length > 0 ? addressLineStyle : undefined}>{data.BilledToEmail}</div>);
        }
    }

    let styleHeader;
    if (content.length > 0 && includes.HeaderLabel) {
        styleHeader = Utilities.Config.getStyle(data, blockProps, 'Header');
    }
    return (
        <Container
            builder={props.builder}
            className={props.className}
            config={props.config}
            onClick={props.onClick}
            onDragStart={props.onDragStart}>
            <tr>
                <td>
                    {
                        content.length > 0 &&
                        <React.Fragment>
                            {
                                includes.HeaderLabel &&
                                <div style={styleHeader}>{blockProps.textLabelHeader}</div>
                            }
                            <div style={styleAddress}>{content}</div>
                        </React.Fragment>
                    }
                    {
                        props.builder &&
                        <React.Fragment>
                            {
                                content.length == 0 &&
                                Utilities.Builder.emptyBlockPlaceholder()
                            }
                            {Utilities.Builder.dragOutline()}
                        </React.Fragment>
                    }

                </td>
            </tr>
        </Container>
    )
}

const TypeConfig = {
    panel: {
        block: function () {
            return {
                label: 'Block Configuration',
                options: [
                    {
                        display: 'Address Type',
                        name: 'addressType',
                        options: [
                            { display: 'Billing', value: 'billing' },
                            { display: 'Shipping', value: 'shipping' }
                        ],
                        relatedProperties: ['textLabelHeader'],
                        type: 'dropdown',
                        value: 'billing'
                    },
                    { type: 'spacer' },
                    { display: 'Header Label Properties', id: 'headerProps', type: 'header' },
                    {
                        default: {
                            billing: 'Bill To:',
                            shipping: 'Ship To:'
                        },
                        display: 'Display Text',
                        name: 'textLabelHeader',
                        relatedProperty: 'addressType',
                        type: 'text',
                        value: 'Bill To:'
                    },
                    { type: 'spacer' },
                    ..._TypeConfig.options.text({ name: 'Header' }, {}, undefined, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Address Data Properties', id: 'addressProps', type: 'header' },
                    ..._TypeConfig.options.text({ name: 'Address' }, {}, {}, {})
                ]
            };
        },
        includes: function () {
            return {
                expanded: false,
                label: 'Include',
                options: [
                    { display: 'Header Label', name: 'HeaderLabel', type: 'checkbox', value: true },
                    { display: 'Contact Name', name: 'ContactName', type: 'checkbox', value: true },
                    { display: 'Spouse Name', name: 'SpouseName', type: 'checkbox', value: true },
                    { display: 'Company', name: 'Company', type: 'checkbox', value: true },
                    { display: 'Home Phone', name: 'PhoneHome', type: 'checkbox', value: true },
                    { display: 'Mobile Phone', name: 'PhoneMobile', type: 'checkbox', value: true },
                    { display: 'Other Phone', name: 'PhoneOther', type: 'checkbox', value: true },
                    { display: 'Email Address', name: 'Email', type: 'checkbox', value: true }
                ]
            };
        },
        style: function () { return _TypeConfig.panel.layoutStyle({}, {}); }
    }
};

module.exports = {
    Component: Address,
    TypeConfig
};